import './i18n';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import storage from 'redux-persist/lib/storage'
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import rootReducer from "./slices";
import { PersistGate } from 'redux-persist/integration/react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { createStateSyncMiddleware } from 'redux-state-sync';
import { SocketProvider } from './contexts/SocketContext';


const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user', 'cart', 'layout']
}
const persistedReducer = persistReducer(persistConfig, rootReducer)

const reduxSyncConfig = {
  whitelist: [
    'cart/setCartState', 'cart/addToCart', 'cart/updateCart', 'cart/removeFromCart', 'cart/clearCart',
    'layout/changeLayoutModeAction', 'layout/changeFontSizeAction',
    'user/loginSuccess', 'user/logout',
  ],
};

const reduxSyncMiddleware = [createStateSyncMiddleware(reduxSyncConfig)];


export const store = configureStore({
  reducer: persistedReducer,
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(reduxSyncMiddleware),
});


const persistor = persistStore(store);


const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <SocketProvider>
        <React.Fragment>
          <BrowserRouter basename="/">
            <ToastContainer closeButton={true} autoClose={500} hideProgressBar={true} style={{ zIndex: 1000 }} newestOnTop={true} />
            <App />
          </BrowserRouter>
        </React.Fragment>
      </SocketProvider>
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
